module.exports = __webpack_public_path__ + "static/media/boss_gym.cff4002b.svg";